import React from 'react';
import img from "./depositphotos_80897014-stock-photo-page-not-found.jpg"
const Error = () => {
    return (
        <div>
            <img src={img} alt="" />
            
        </div>
    );
};

export default Error;